"use strict";

exports.__esModule = true;
exports.getPoolId = getPoolId;
function getPoolId(pool) {
  return pool.toHex();
}